"use client";

import { Button, Badge } from "@heroui/react";
import { Filter } from "lucide-react";

interface FilterButtonProps {
  onToggle: () => void;
  activeFilterCount: number;
}

export default function FilterButton({
  onToggle,
  activeFilterCount,
}: FilterButtonProps) {
  return (
    <Button
      onPress={onToggle}
      startContent={<Filter className="w-4 h-4" />}
      size="md"
      className="rounded-md"
      variant="flat"
    >
      Filters
      {activeFilterCount > 0 && (
        <Badge color="primary" size="sm">
          {activeFilterCount}
        </Badge>
      )}
    </Button>
  );
}
